/* eslint-disable jsx-quotes */
import React from 'react';
import MetaSeo from '../MetaSeo';
import useTrans from '@/hooks/useTrans';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import TextFooter from '../TextFooter';
import styles from './partner.module.css';

const About = props => {
  const trans = useTrans();
  let partners = props.partners || [];
  let seo = props.seo || {};
  const {title_seo, description, text_footer} = seo;
  const dataSeo = {
    description: description || '',
    title: title_seo || 'Hanagold - Đối tác của chúng tôi',
    url: "https://hanagold.vn/doi-tac",
    image: "https://hanagold.vn/assets/img/aff/partner_seo.png?t=1"
  };
  return (
    <>
      <MetaSeo {...dataSeo}/>
      <div className="about_container">
        <div className="about_content">
          <div className={styles.about_img}></div>
          <div className={styles.about_text}>
            <div className='aff_breadcrumb_component'>
              <BreadcrumbComponent title='Đối tác doanh nghiệp' url='doi-tac'/>
            </div>
            <h1>{trans?.partners?.title}</h1>
            <div className={styles.about_details}>
              <div className={styles.about_details_items_f}>
                {partners.map(it => (
                  <div className={styles.about_details_item_f} key={`gr-${it.id}`}>
                    <h2>{it.title}</h2>
                    <div className={styles.about_details_item_img}>
                      {it.partner.map(pt => (
                        <div key={`pt-${pt.id}`}>
                          <a href={pt.link_url} target="_blank">
                            <img src={pt.image} alt={pt.title} />
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <TextFooter text={text_footer} has_background/>
    </>
  );
};

export default About;
